import { render, staticRenderFns } from "./textOptional.vue?vue&type=template&id=4e2fb962&"
import script from "./textOptional.vue?vue&type=script&lang=js&"
export * from "./textOptional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports